import { createFrontendTracker } from './typedTracker'
import type { AnalyticsEvents } from '@omnea-app/packages/universal/analytics'

/**
 * Module-level singleton tracker. Safe to use at import time — the underlying
 * Segment client is lazily resolved via a promise, so early calls are buffered.
 */
const tracker = createFrontendTracker<AnalyticsEvents>()

/**
 * Typed track function for analytics events. Works in React components and plain functions.
 * The annotation keeps `keyof AnalyticsEvents` symbolic in the declaration output; without it the
 * emitter freezes the event union at build time and downstream augmentations cannot extend it.
 */
export const track: <E extends keyof AnalyticsEvents>(event: E, properties: AnalyticsEvents[E]) => void = tracker.track
